export const isGreaterThanZero = (input): boolean => {
  if (!isNaN(input)) {
    return input > 0;
  }
  return false;
};
